<template>
  <div v-show="cordivariId == null" class="login-form">
    <div class="col-md-4 col-md-offset-4 login-form--to-center">
      <div class="panel panel-default">
        <div class="panel-heading">
          <h3 class="panel-title">Please Sign In</h3>
        </div>
        <div class="panel-body">
          <fieldset>
            <div class="form-group">
              <label>Login (email)</label>
              <input
                v-model="email"
                class="form-control"
                placeholder="Login"
                name="login"
                autofocus
                autocomplete="off"
                @keyup.enter="onClickSubmit"
              />
            </div>
            <div class="form-group">
              <label>Password</label>
              <input
                v-model="password"
                class="form-control"
                placeholder="Password"
                name="password"
                type="password"
                @keyup.enter="onClickSubmit"
              />
            </div>
            <div class="form-group" style="display:flex">
              <button
                type="submit"
                name="loginForm"
                value="check"
                class="btn btn-lg btn-success btn-block"
                @click="onClickSubmit"
              >
                Login
              </button>
            </div>
          </fieldset>

          <br />
          <!-- Or go to <router-link to="/register">Register</router-link> form -->
        </div>
        <div v-if="loading" class="status">loading...</div>
        <div v-if="error" class="error-message">{{ error }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

export default {
  name: "LoginForm",
  data() {
    return {
      email: "",
      password: "",
      error: null,
      loading: false
    };
  },
  methods: {
    ...mapActions("_authModule", [
      "loginAction",
      "userInfoAction",
      "isAdminAction",
      "isUnilabAction",
      "isDebugAction",
      "automaticLoginAction"
    ]),
    ...mapActions("_prjModule", ["clear"]),
    ...mapActions("_translationModule", ["changeLanguageAction", "setLanguages"]),
    onClickSubmit() {
      this.error = null;
      this.loading = true;

      var that = this;
      var userModel = {
        email: this.email,
        password: this.password
      };
      this.loginAction(userModel)
        .then(() => {
          that.userInfoAction().then(() => {
            that.isAdminAction().then(() => {
              that.isUnilabAction().then(() => {
                that.isDebugAction(window.location.href.includes("localhost:808")).then(() => {
                  //
                  that.clear();
                  that.setLanguages().then(() => {
                    that.changeLanguageAction("en-US").then(() => {
                      that.$router.push("/").catch(() => {});
                    });
                  });
                });
              });
            });
          });
        })
        .catch(err => {
          this.error = err.response ? err.response.data.message : err;
        })
        .finally(() => {
          this.loading = false;
        });
    }
  },
  mounted() {
    var that = this;

    if (that.cordivariId != null) {
      that.automaticLoginAction().then(() => {
        that.userInfoAction().then(() => {
          that.isAdminAction().then(() => {
            that.isUnilabAction().then(() => {
              that.isDebugAction(window.location.href.includes("localhost:808")).then(() => {
                //
                that.clear();
                that.setLanguages().then(() => {
                  //that.changeLanguageAction("en-US").then(() => {
                    that.$router.push("/").catch(() => {});
                  //});
                });
              });
            });
          });
        });
      });
    }
  },
  computed: {
    ...mapGetters("_authModule", ["cordivariId"])
  }
};
</script>

<style lang="scss" scoped>
.login-form {
  height: 100vh;
  width: 100%;
  display: flex;
  justify-content: center;

  &--to-center {
    margin: 100px auto 0;
    @media (max-width: 425px) {
      margin: 30px auto 0;
    }
  }

  .error-message {
    color: tomato;
  }
}
</style>
